/* Copiar URL del post — robusto por contenedor */
export default function initCopyUrl() {
  const wrappers = document.querySelectorAll(".share-buttons");
  if (!wrappers.length) return;

  wrappers.forEach((wrap) => {
    const copyButton = wrap.querySelector(".js-copy-post-url-button");
    const feedback = wrap.querySelector(".feedback-message");

    if (!copyButton || !feedback) return;

    copyButton.addEventListener("click", async () => {
      const urlToCopy = window.location.href;

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(urlToCopy);
        } else {
          // Fallback legacy
          const ta = document.createElement("textarea");
          ta.value = urlToCopy;
          ta.setAttribute("readonly", "");
          ta.style.position = "absolute";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }

        feedback.textContent = "¡Enlace copiado!";
        feedback.classList.add("is-visible");
        setTimeout(() => feedback.classList.remove("is-visible"), 2000);
      } catch (err) {
        feedback.textContent = "No se pudo copiar";
        feedback.classList.add("is-visible");
        setTimeout(() => feedback.classList.remove("is-visible"), 2000);
        console.error("Error al copiar la URL del post:", err);
      }
    });
  });
}
